import React from "react";
import clsx from "clsx";

import { OnePagePortfolioAssessmentQuestionAnswers } from "../../../../state";

import styles from "./OneAnswerBox.module.scss";

type Props = {
  questionAnswers: OnePagePortfolioAssessmentQuestionAnswers[];
  isHighlighted?: boolean;
};

export const OneAnswerBox = ({ questionAnswers, isHighlighted }: Props) => {
  return (
    <div
      className={clsx(styles.container, isHighlighted && styles.highlighted)}
    >
      <div className={styles.body}>
        {questionAnswers.map(qa => (
          <div key={qa.id} className={styles.content}>
            <p className={styles.question}>{qa.title}</p>
            {qa.one_page_portfolio_assessment_answers.map(a => (
              <p key={a.id} className={styles.answer}>
                {a.contents}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OneAnswerBox;
